"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementValidationResultDtoFailingPropsFromJSON = RequirementValidationResultDtoFailingPropsFromJSON;
exports.RequirementValidationResultDtoFailingPropsFromJSONTyped = RequirementValidationResultDtoFailingPropsFromJSONTyped;
exports.RequirementValidationResultDtoFailingPropsToJSON = RequirementValidationResultDtoFailingPropsToJSON;
exports.RequirementValidationResultDtoFailingPropsToJSONTyped = RequirementValidationResultDtoFailingPropsToJSONTyped;
const ConflictsFailingPropsDto_1 = require("./ConflictsFailingPropsDto");
const ExpirationDatesFailingPropsDto_1 = require("./ExpirationDatesFailingPropsDto");
function RequirementValidationResultDtoFailingPropsFromJSON(json) {
    return RequirementValidationResultDtoFailingPropsFromJSONTyped(json, false);
}
function RequirementValidationResultDtoFailingPropsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if ((0, ConflictsFailingPropsDto_1.instanceOfConflictsFailingPropsDto)(json)) {
        return (0, ConflictsFailingPropsDto_1.ConflictsFailingPropsDtoFromJSONTyped)(json, true);
    }
    if ((0, ExpirationDatesFailingPropsDto_1.instanceOfExpirationDatesFailingPropsDto)(json)) {
        return (0, ExpirationDatesFailingPropsDto_1.ExpirationDatesFailingPropsDtoFromJSONTyped)(json, true);
    }
    return {};
}
function RequirementValidationResultDtoFailingPropsToJSON(json) {
    return RequirementValidationResultDtoFailingPropsToJSONTyped(json, false);
}
function RequirementValidationResultDtoFailingPropsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if ((0, ConflictsFailingPropsDto_1.instanceOfConflictsFailingPropsDto)(value)) {
        return (0, ConflictsFailingPropsDto_1.ConflictsFailingPropsDtoToJSON)(value);
    }
    if ((0, ExpirationDatesFailingPropsDto_1.instanceOfExpirationDatesFailingPropsDto)(value)) {
        return (0, ExpirationDatesFailingPropsDto_1.ExpirationDatesFailingPropsDtoToJSON)(value);
    }
    return {};
}
//# sourceMappingURL=RequirementValidationResultDtoFailingProps.js.map